import SearchParamsBase from '../../../Elements/SearchParamsBase';
import EvaluatorPaymentViewsEnum from '../../../Enums/EvaluatorPaymentViewsEnum';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import OfficeHelper from '../../../Helpers/ModelHelpers/OfficeHelper';
import selectHelper from '../../../Helpers/selectHelper';
import UserService from '../../../Services/userService';

export default class AssignmentPaymentsAdminSearchParams extends SearchParamsBase {
  initialize() {
    this.View = EvaluatorPaymentViewsEnum.PendingApproval;
    this.AsSassieAsgnId = '';
    this.IeExportPaymentId = '';
    this.IeStatusCode = '';
    this.IePaymentType = '';
    this.Method = '';
    this.AssignmentType = '';
    this.EvaluatorNameOrId = '';
    this.EvaluatorEmail = '';
    this.ClientNameOrId = '';
    this.ProjectNameOrId = '';
    this.IeTypeCode = '';
    this.SelectedAssignmentCountryCodes = [];
    this.SelectedPaymentOffices = OfficeHelper.GetDefaultOfficeIds(UserService.GetOfficeIdOfLoggedInUser());
    this.SelectedAssignmentStatuses = [];
    this.CreatedBy = '';
    this.EmptyPayment = '';
    this.IeId = '';
    this.UrlModifiableParams = ['View'];
  }

  static fieldsInSearchBox = [
    {
      fieldName: 'View',
      label: 'View',
      className: 'col-4',
      type: InputTypesEnum.Select,
      options: AssignmentPaymentsAdminSearchParams.getViewSelectOptions(),
    },
    { fieldName: 'AsSassieAsgnId', label: 'Apollo Job ID', className: 'col-2', type: InputTypesEnum.Text },
    { fieldName: 'IeId', label: 'Pay ID', className: 'col-2', type: InputTypesEnum.Text },
    { fieldName: 'EvaluatorNameOrId', label: 'Evaluator Name or ID', className: 'col-4', type: InputTypesEnum.Text },
    { fieldName: 'EvaluatorEmail', label: 'Evaluator Email', className: 'col-4', type: InputTypesEnum.Text },
    { fieldName: 'ClientNameOrId', label: 'Client Name or ID', className: 'col-4', type: InputTypesEnum.Text },
    { fieldName: 'ProjectNameOrId', label: 'Project Name or ID', className: 'col-4', type: InputTypesEnum.Text },
    {
      fieldName: 'SelectedAssignmentCountryCodes',
      label: 'Country',
      className: 'col-6',
      type: InputTypesEnum.CountryCodeMultiChoice,
    },
    {
      fieldName: 'SelectedPaymentOffices',
      label: 'Payment Office',
      className: 'col-6',
      type: InputTypesEnum.OfficeOrGroupMultiSelect,
      disabled: (searchItem) =>
        [
          EvaluatorPaymentViewsEnum.MyOfficePendingApproval,
          EvaluatorPaymentViewsEnum.MyOfficePaymentRequestsPendingApproval,
          EvaluatorPaymentViewsEnum.MyOfficePendingReview,
          EvaluatorPaymentViewsEnum.MyOfficeEmptyPayments,
          EvaluatorPaymentViewsEnum.MyOfficePaymentRequests,
        ].includes(searchItem.View),
    },
    {
      fieldName: 'IeTypeCode',
      label: 'Type',
      className: 'col-2',
      type: InputTypesEnum.EvaluatorPaymentTypeLookupItemSelect,
      disabled: (searchItem) =>
        [
          EvaluatorPaymentViewsEnum.MyPaymentRequestsPendingApproval,
          EvaluatorPaymentViewsEnum.MyOfficePaymentRequestsPendingApproval,
          EvaluatorPaymentViewsEnum.MyPaymentRequests,
          EvaluatorPaymentViewsEnum.MyPaymentRequestsInformationRequired,
          EvaluatorPaymentViewsEnum.MyOfficePaymentRequests,
        ].includes(searchItem.View),
    },
    {
      fieldName: 'IeStatusCode',
      label: 'Status',
      className: 'col-4',
      type: InputTypesEnum.EvaluatorPaymentStatusLookupItemSelect,
      disabled: (searchItem) =>
        [
          EvaluatorPaymentViewsEnum.MyOfficePendingApproval,
          EvaluatorPaymentViewsEnum.MyPaymentRequestsPendingApproval,
          EvaluatorPaymentViewsEnum.MyOfficePaymentRequestsPendingApproval,
          EvaluatorPaymentViewsEnum.PendingApproval,
          EvaluatorPaymentViewsEnum.MyPaymentRequestsInformationRequired,
        ].includes(searchItem.View),
    },
    {
      fieldName: 'SelectedAssignmentStatus',
      label: 'Assignment Status',
      className: 'col-4',
      type: InputTypesEnum.Select,
      options: AssignmentPaymentsAdminSearchParams.getStatusValues(),
    },
    { fieldName: 'EmptyPayment', label: 'Empty Payment', className: 'col-2', type: InputTypesEnum.EmptyYesNoSelect },
    { fieldName: 'CreatedBy', label: 'Created By', className: 'col-6', type: InputTypesEnum.UserSelect },
  ];

  static getViewSelectOptions() {
    return selectHelper.generateSelectValues([
      EvaluatorPaymentViewsEnum.AllPaymentRequests,
      EvaluatorPaymentViewsEnum.MyOfficePendingApproval,
      EvaluatorPaymentViewsEnum.MyPaymentRequestsPendingApproval,
      EvaluatorPaymentViewsEnum.MyOfficePaymentRequestsPendingApproval,
      EvaluatorPaymentViewsEnum.PendingApproval,
      EvaluatorPaymentViewsEnum.PendingReview,
      EvaluatorPaymentViewsEnum.MyOfficePendingReview,
      EvaluatorPaymentViewsEnum.MyPaymentRequests,
      EvaluatorPaymentViewsEnum.MyOfficeEmptyPayments,
      EvaluatorPaymentViewsEnum.MyPaymentRequestsInformationRequired,
      EvaluatorPaymentViewsEnum.AllEmptyPayments,
      EvaluatorPaymentViewsEnum.MyOfficePaymentRequests,
    ]);
  }

  static getStatusValues() {
    return [
      { label: '', value: '', disabled: false },
      { label: 'Created', value: '0', disabled: false },
      { label: 'New', value: '1', disabled: false },
      { label: 'Incomplete', value: '2', disabled: false },
      { label: 'Completed', value: '3', disabled: false },
      { label: 'Collaboration Shop', value: '4', disabled: false },
      { label: 'Excluded', value: '5', disabled: false },
      { label: 'Hold A', value: '6', disabled: false },
      { label: 'Hold B', value: '7', disabled: false },
      { label: 'Reviewed', value: '8', disabled: false },
      { label: 'Finalized', value: '9', disabled: false },
      { label: 'Emailed', value: '10', disabled: false },
      { label: 'Client Finalized', value: '12', disabled: false },
      { label: 'Locked', value: '15', disabled: false },
      { label: 'Deleted in Apollo', value: '23', disabled: false },
    ];
  }

  static iconName = 'fa-solid fa-search';
  static saveType = 'AssignmentPaymentsAdminSearchParams';
}
